// extracted by mini-css-extract-plugin
module.exports = {"nav-wrapper":"SliderNavIndicator_nav-wrapper__7ioOG","slide-indicator":"SliderNavIndicator_slide-indicator__xs3wF","button":"SliderNavIndicator_button__Gym40"};